/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ResponsiveImage from "../../../../../../components/ResponsiveImage";
import Strip from "../../../../../../components/Strip";
import ReactMarkdown from "react-markdown";
import AnimationOnScroll from "react-animate-on-scroll";
import Box from "@mui/material/Box";

function InvolvementStrip() {
  const { t } = useTranslation("dmuk");
  return (
    <Strip variant="neutral">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <AnimationOnScroll animateIn="animate__fadeIn">
            <ResponsiveImage
              src="/images/fituk.jpg"
              alt={t("involvement.imgAlt")}
            />
          </AnimationOnScroll>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box textAlign={{ xs: "center", sm: "left" }}>
            <Typography
              variant="body1"
              component="p"
              gutterBottom
              align="inherit"
              color="secondary.contrastText"
            >
              {t("involvement.pre")}
            </Typography>
            <Typography
              variant="h4"
              component="h2"
              align="inherit"
              gutterBottom
            >
              {t("faqs.sections.2.2.q")}
            </Typography>
          </Box>
          <Typography variant="body1" paragraph component="p">
            {t("faqs.sections.2.2.a")}
          </Typography>
          <Box textAlign={{ xs: "center", sm: "left" }}>
            <Typography
              variant="h5"
              component="h3"
              align="inherit"
              gutterBottom
            >
              {t("faqs.sections.2.3.q")}
            </Typography>
          </Box>
          <Typography variant="body1" component="span">
            <ReactMarkdown>{t("faqs.sections.2.3.a")}</ReactMarkdown>
          </Typography>
        </Grid>
      </Grid>
    </Strip>
  );
}

export default InvolvementStrip;
